/**
 * DELETED-PATH SHIM (P3 · monorepo-wave-1-p3-feature-flags · Z2).
 *
 * The legacy `IS_*` flag declarations have moved to
 * `src/features/flags/legacy-flags.ts`, behind the `@/features/flags` barrel.
 * This file remains ONLY as a pure re-export shim so the existing importers
 * keep compiling while the Z1 codemod batches rewrite them onto the canonical
 * `@/features/flags` surface. It is deleted at Z3 once its external importer
 * count reaches zero.
 *
 * New code: import from `@/features/flags` (the direct import here is
 * lint-flagged at `warn` until Z3 flips it to `error`).
 */
export * from '@/features/flags/legacy-flags';
